import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!supabaseUrl || !supabaseKey) {
  // Fail loudly so the site refuses to render rather than silently breaking.
  // The founder's cockpit should never degrade to anonymous mode.
  console.error('[jamie.intervyo] Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl || '', supabaseKey || '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Bypass the lock that causes hangs — same fix as the main app's client.
    lock: async (_name: string, _acquireTimeout: number, fn: () => Promise<any>) => fn(),
    storageKey: 'intervyo-jamie-auth', // isolated from the main app's storage key
  },
});

/** The ONLY user_id allowed to use this site. */
export const ALLOWED_USER_ID = (import.meta.env.VITE_ALLOWED_USER_ID as string | undefined) ?? '';
